import { render, staticRenderFns } from "./Bookingtidspunkt.vue?vue&type=template&id=5a84a338"
import script from "./Bookingtidspunkt.vue?vue&type=script&lang=js"
export * from "./Bookingtidspunkt.vue?vue&type=script&lang=js"
import style0 from "./Bookingtidspunkt.vue?vue&type=style&index=0&id=5a84a338&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports